import { useContext } from 'react';

import { ThemeContext } from './provider';

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  return ctx || { themeStyles: {} };
};
